var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTouch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_359_6669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75539 5.09152C3.26469 4.2416 3.5559 3.15482 4.40581 2.66412C5.25573 2.17342 6.34251 2.46462 6.83321 3.31454L8.61887 6.40739C8.72819 6.29681 8.85394 6.19886 8.99512 6.11735C9.60317 5.76629 10.3325 5.81544 10.878 6.18307C11.0189 5.99188 11.2007 5.826 11.4196 5.69964C12.0611 5.32925 12.8376 5.40436 13.3909 5.82897C13.5404 5.51828 13.7818 5.24776 14.1029 5.06234C14.9529 4.57164 16.0396 4.86284 16.5303 5.71276L19.7036 11.2089C20.4529 12.5069 20.055 14.1524 18.8243 14.9711L18.8272 14.9761L14.4172 17.5222C14.3876 17.5393 14.3573 17.5542 14.3266 17.567C14.3008 17.5868 14.2735 17.6052 14.2445 17.6219C13.4778 18.0646 12.5894 18.1061 11.8227 17.8115C11.7924 17.8041 11.7621 17.7958 11.7319 17.7867L6.35379 16.1637C5.41424 15.8802 4.88242 14.8887 5.16594 13.9492C5.44946 13.0096 6.44096 12.4778 7.38051 12.7613L8.35299 13.0548L3.75539 5.09152Z",
    fill: "#FFD456"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.73678 1.45645C2.20619 2.34014 1.68177 4.2973 2.56546 5.8279C2.70726 6.0735 2.62311 6.38756 2.3775 6.52936C2.1319 6.67116 1.81784 6.58701 1.67604 6.3414C0.508753 4.3196 1.20147 1.73432 3.22328 0.567034C5.24509 -0.600256 7.83036 0.0924658 8.99765 2.11427C9.13945 2.35988 9.0553 2.67393 8.80969 2.81573C8.56409 2.95753 8.25003 2.87338 8.10823 2.62778C7.22454 1.09718 5.26738 0.572762 3.73678 1.45645Z",
    fill: "#FFD456"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_359_6669",
    x: 0.109009,
    y: 0,
    width: 19.9734,
    height: 19,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_359_6669"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_359_6669",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTouch);
export default __webpack_public_path__ + "static/media/Touch.164c731f57616fcd0608001c778e82d8.svg";
export { ForwardRef as ReactComponent };